import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { CoreFeatureProgressBarLoaderModule } from '@nx-ratenow/core/feature-progress-bar-loader';
import { UiLayaoutComponent } from './ui-layaout/ui-layaout.component';

@NgModule({
  imports: [CommonModule, RouterModule, MatSidenavModule, CoreFeatureProgressBarLoaderModule],
  declarations: [UiLayaoutComponent],
  exports: [UiLayaoutComponent]
})
export class CoreLayoutFeatureLayoutModule {}
